export default __webpack_public_path__ + "static/media/map_south_east_asia.0de6d401.png";